"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsVisible = void 0;
const react_1 = require("react");
const useIsVisible = (ref) => {
    const [isIntersecting, setIntersecting] = (0, react_1.useState)(false);
    const observer = (0, react_1.useRef)(new IntersectionObserver((entries) => setIntersecting(entries[0].isIntersecting)));
    (0, react_1.useEffect)(() => {
        const { current } = observer;
        current.observe(ref.current);
        return () => current.disconnect();
    }, [ref]);
    return isIntersecting;
};
exports.useIsVisible = useIsVisible;
